var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Header',{staticClass:"header"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../assets/Logoonly@2x.png")}})]),_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.type === 'digitalMap' && _vm.device === 'rn' ? 'Mapxus Map React Native SDK Doc' : 'Mapxus Map SDK Doc')+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }